const exceptions = {
  and: true,
  in: true,
  of: true,
  or: true,
  with: true,
};

export const titalize = (str: string): string =>
  str
    .split(" ")
    .map((s, index) =>
      index === 0 || !(s in exceptions) ? `${s.charAt(0).toUpperCase()}${s.slice(1)}` : s,
    )
    .join(" ");
